import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import {
  Flex,
  Text,
  Box,
  FormField,
  Input,
  Button,
  Tooltip
} from 'pcln-design-system'
import { Smartphone } from 'pcln-icons'

type PhoneEntryType = {
  clientGUID?: string
  ipAddr?: string
  referral: {
    clickId?: string
    id?: string
    sourceId?: string
  }
}
type FormValues = {
  phoneNumber: string
}

export default function PhoneEntry({
  clientGUID = '',
  ipAddr = '',
  referral = {}
}: PhoneEntryType) {
  const { register, watch, handleSubmit, setValue } = useForm<FormValues>()
  const watchNumber = watch('phoneNumber')

  const [success, setSuccess] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleSubmitNumber = async (values: FormValues) => {
    const { phoneNumber } = values
    const validFormat = /^\d{3}[-]\d{3}[-]\d{4}$/.test(phoneNumber)
    if (validFormat) {
      const URL = '/svcs/eng/gblsvcs/v1/sms/send'
      const submission = {
        cguid: clientGUID,
        guid: '98181227f7c74e28a6b43c9e7f3ed879',
        ipAddr,
        pageId: 'DESK_HP_T2D_TXT',
        refClickId: referral.clickId,
        refId: referral.id,
        refSourceId: referral.sourceId,
        smsContent: 'TEST',
        toPhoneNo: phoneNumber
      }
      try {
        const response = await fetch(URL, {
          method: 'POST',
          body: JSON.stringify(submission),
          headers: { 'content-type': 'application/json' }
        })
        if (response.ok) {
          const body = await response.json()
          if (body.messageSent) {
            setSuccess(true)
          } else {
            setError('Please check the number you have entered')
            throw new Error(body.errorDesc || 'Phone registration failure')
          }
        } else {
          setError('Please check the number you have entered')
          throw new Error(response.statusText || 'Phone registration failure')
        }
      } catch (err) {
        setError('Please check the number you have entered')
      }
    } else {
      setError('Please check the number you have entered')
    }
  }
  return (
    <Box mb={4}>
      {success ? (
        <Box>
          <Text bold color="success" textAlign="center">
            We&apos;ve sent a link to the number you provided.
            <br />
            Happy Savings!
          </Text>
        </Box>
      ) : (
        <form
          aria-label="phone-number-entry-form"
          onSubmit={handleSubmit(handleSubmitNumber)}
        >
          <Flex height="48px">
            <Box width={1} mr={2} bg="background.lightest">
              <FormField>
                <Smartphone />
                <Input
                  type="tel"
                  style={{ width: '100%' }}
                  name="phoneNumber"
                  ref={register({ required: true })}
                  placeholder="Enter your phone number"
                  value={watchNumber || null}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    const number = e.target.value
                    let formatNumber = number.replace(/[\s|(|)|.|-]/g, '')
                    const match = formatNumber.match(/^(\d{3})(\d{3})(\d{4})$/)
                    if (match) {
                      formatNumber = `${match[1]}-${match[2]}-${match[3]}`
                    }
                    setValue('phoneNumber', formatNumber)
                  }}
                />
              </FormField>
              <Box>
                {error && (
                  <Tooltip bottom right color="error">
                    {error}
                  </Tooltip>
                )}
              </Box>
            </Box>
            <Button width={1 / 2} type="submit">
              <Text fontSize={2} textAlign="center" m="auto">
                Send Link
              </Text>
            </Button>
          </Flex>
        </form>
      )}
    </Box>
  )
}
